import React from "react";
import PropTypes from "prop-types";
import Salad from "~/static/images/icons/vegan/salad.svg";

const VeganOverlay = ({ text }) => {
    return (
        <div className="vegan-overlay">
            <img src={Salad} alt="" />
            <p>{text}</p>
        </div>
    );
};

VeganOverlay.propTypes = {
    text: PropTypes.string.isRequired,
};

export default VeganOverlay;
